// extracted by mini-css-extract-plugin
export default {"mood-wall":"mood-wall","moodWall":"mood-wall","bg-shapes-1":"bg-shapes-1","bgShapes1":"bg-shapes-1","bg-shapes-2":"bg-shapes-2","bgShapes2":"bg-shapes-2","inner":"inner"};